const STANDARD_STATUS_LABELS = {
  Pending: "Pending",
  Approved: "Approved",
  Preparation: "Preparation",
  Shipped: "Shipped",
  Delivered: "Delivered",
  "Follow Up": "Follow Up",
  Completed: "Completed",
  "Converted to Order": "Converted to Order",
  Cancelled: "Cancelled",
  Received: "Delivered",
};

const INDUSTRY_STATUS_LABELS = {
  seafood: {
    Pending: "Sample Requested",
    Approved: "Approved / Confirmed",
    Preparation: "Packed on Ice",
    Shipped: "Out for Delivery",
    Delivered: "Delivered",
    "Follow Up": "Taste Follow-Up",
    Completed: "Sample Closed",
    "Converted to Order": "Converted to Order",
    Cancelled: "Cancelled",
  },
  meat: {
    Pending: "Sample Requested",
    Approved: "Approved / Confirmed",
    Preparation: "Cut / Packed",
    Shipped: "Out for Delivery",
    Delivered: "Delivered",
    "Follow Up": "Buyer Follow-Up",
    Completed: "Sample Closed",
    "Converted to Order": "Converted to Order",
    Cancelled: "Cancelled",
  },
  dairy: {
    Pending: "Sample Requested",
    Approved: "Approved / Confirmed",
    Preparation: "Pulled / Refrigerated",
    Shipped: "On Route / Cold Delivery",
    Delivered: "Delivered",
    "Follow Up": "Quality Follow-Up",
    Completed: "Sample Closed",
    "Converted to Order": "Converted to Order",
    Cancelled: "Cancelled",
  },
  produce: {
    Pending: "Sample Requested",
    Approved: "Approved / Confirmed",
    Preparation: "Picked / Packed",
    Shipped: "Out for Delivery",
    Delivered: "Delivered",
    "Follow Up": "Freshness Follow-Up",
    Completed: "Sample Closed",
    "Converted to Order": "Converted to Order",
    Cancelled: "Cancelled",
  },
  baking: {
    Pending: "Sample Requested",
    Approved: "Approved / Scheduled",
    Preparation: "Baked / Packed",
    Shipped: "Out for Delivery",
    Delivered: "Delivered / Picked Up",
    "Follow Up": "Feedback Follow-Up",
    Completed: "Sample Closed",
    "Converted to Order": "Converted to Order",
    Cancelled: "Cancelled",
  },
};

const COMPANY_TYPE_ALIASES = {
  seafood: "seafood",
  "sea food": "seafood",
  meat: "meat",
  dairy: "dairy",
  produce: "produce",
  baking: "baking",
  bakery: "baking",
};

export const SAMPLE_ORDER_STATUS_FLOW = [
  "Pending",
  "Approved",
  "Preparation",
  "Shipped",
  "Delivered",
  "Follow Up",
  "Completed",
  "Converted to Order",
];

const normalizeKey = (value) =>
  (value || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");

export const canonicalSampleOrderStatus = (status) => {
  const normalized = normalizeKey(status);
  switch (normalized) {
    case "pending":
      return "Pending";
    case "approved":
      return "Approved";
    case "preparation":
      return "Preparation";
    case "shipped":
      return "Shipped";
    case "delivered":
    case "received":
      return "Delivered";
    case "follow up":
    case "followup":
      return "Follow Up";
    case "completed":
      return "Completed";
    case "converted to order":
    case "converted order":
      return "Converted to Order";
    case "cancelled":
    case "canceled":
      return "Cancelled";
    default:
      return status || "Pending";
  }
};

export const normalizeCompanyType = (companyType) => {
  const normalized = normalizeKey(companyType);
  return COMPANY_TYPE_ALIASES[normalized] || "";
};

export const shouldUseIndustrySampleStatusLabels = (settings = {}) =>
  settings?.useIndustrySampleStatusLabels === true;

export const getSampleOrderStatusLabel = (status, settings = {}) => {
  const canonical = canonicalSampleOrderStatus(status);
  if (!shouldUseIndustrySampleStatusLabels(settings)) {
    return STANDARD_STATUS_LABELS[canonical] || canonical;
  }

  const typeKey = normalizeCompanyType(settings?.companyType || settings?.businessType);
  const labels = INDUSTRY_STATUS_LABELS[typeKey];
  if (!labels) return STANDARD_STATUS_LABELS[canonical] || canonical;
  return labels[canonical] || STANDARD_STATUS_LABELS[canonical] || canonical;
};

export const getSampleOrderStatusPreview = (settings = {}) =>
  SAMPLE_ORDER_STATUS_FLOW.map((status) => ({
    status,
    label: getSampleOrderStatusLabel(status, settings),
  }));
